module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-popup', {
    staticStyle: {
      "height": "60%"
    },
    attrs: {
      "position": "bottom",
      "close-on-click-overlay": false
    },
    on: {
      "click-overlay": _vm.onClose
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "coupon-list-select"
  }, _vm._l((_vm.fList), function(item, index) {
    return _c('div', {
      staticClass: "conpun-list flex-start",
      on: {
        "click": function($event) {
          return _vm.onCouponClick(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "coupon-left"
    }, [_c('div', {
      staticClass: "coupon-name"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "coupon-detail flex-start"
    }, [_c('div', {
      staticClass: "coupon-num flex-start"
    }, [_c('span', [_vm._v("¥")]), _vm._v(_vm._s(_vm._f("price")(item.price)) + "\n                        ")]), _vm._v(" "), (item.can_not_use_reason) ? _c('div', {
      staticClass: "coupon-user coupon-condition"
    }, [_vm._v(_vm._s(item.can_not_use_reason))]) : _vm._e()])]), _vm._v(" "), (item.status_type == 'can_use') ? _c('div', {
      staticClass: "coupon-right"
    }, [(!item.checked) ? _c('div', {
      staticClass: "coupon-get coupon-draw"
    }, [_vm._v("立即使用")]) : _c('div', {
      staticClass: "coupon-get coupon-cancle"
    }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
      staticClass: "coupon-limit gray-light"
    }, [_vm._v("有效期" + _vm._s(item.use_time_end_str))])]) : _c('div', {
      staticClass: "coupon-right"
    }, [_c('div', {
      staticClass: "coupon-get coupon-error"
    }, [_vm._v("不可用")]), _vm._v(" "), _c('div', {
      staticClass: "coupon-limit gray-light"
    })])])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2953de8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CouponPicker.vue
// module id = 2268
// module chunks = 0